module.exports = __webpack_public_path__ + "ae24ed0c9a034d7c4098d3ddcdcb57f2.woff2";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-SemiBoldItalic.woff2
// module id = 376
// module chunks = 0